import { render, staticRenderFns } from "./PostponementsList.vue?vue&type=template&id=570ebae6&"
import script from "./PostponementsList.vue?vue&type=script&lang=js&"
export * from "./PostponementsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports